import React  from 'react';

function OnOffButton(props) {
  return (
      <button
        className={"resautcat-on-off-button" + (props.selected ? ' selected' : '')}
        onClick={e => props.onClick(e)}
        title={props.title || false}
      >
        <div className="resautcat-on-off-button-back"></div>
        <div className="resautcat-on-off-button-round"></div>
      </button>
  );
}

export default OnOffButton;